import React from 'react';

const IconJournal = props => (<svg viewBox="0 0 20 20" width="20px" height="20px" {...props}>
  <path d="M10 5.686c-2.261-0.903-4.73-0.903-6.991 0v9.306c2.261-0.904 4.73-0.904 6.991 0c2.259-0.904 4.73-0.904 6.99 0V5.686 C14.73 4.783 12.26 4.783 10 5.686z" />
</svg>);

export default IconJournal;
